import { render } from "./flowManagement.vue?vue&type=template&id=8e493092&scoped=true"
import script from "./flowManagement.vue?vue&type=script&lang=js"
export * from "./flowManagement.vue?vue&type=script&lang=js"

import "./flowManagement.vue?vue&type=style&index=0&id=8e493092&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8e493092"

export default script